type CompassRoseProps = {
  className?: string;
};

/** Minimal chart compass: ring, cardinal ticks, needle pointing mostly north. */
export function CompassRose({ className = "" }: CompassRoseProps) {
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden focusable="false">
      <g stroke="currentColor" fill="none" strokeWidth="1.5">
        <circle cx="40" cy="44" r="26" vectorEffect="non-scaling-stroke" />
        <path d="M40 12v6M40 70v6M8 44h6M66 44h6" vectorEffect="non-scaling-stroke" strokeLinecap="round" />
      </g>
      <path d="M40 26l6 18-6-4-6 4Z" className="fill-signal" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      <path d="M40 62l-6-18 6 4 6-4Z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      <text
        x="40"
        y="8"
        textAnchor="middle"
        className="font-mono"
        fontSize="9"
        fill="currentColor"
      >
        N
      </text>
    </svg>
  );
}
